import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { BLOG_POSTS } from './constants';
import { SectionContainer, Container, SectionHeader, SectionTitle, Grid, Content, Card, Tag, CardTitle, Excerpt, BlogMeta, BlogLink, } from './Blog.styles';
import { useAnalytics } from '../../../hooks/useAnalytics';
const Blog = ({ onBlogClick }) => {
    const { trackSectionView, trackExternalLink, trackClick } = useAnalytics();
    const sectionRef = useRef(null);
    // Track section view when it comes into viewport
    useEffect(() => {
        if (typeof window === 'undefined' || !sectionRef.current)
            return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    trackSectionView('blog');
                    observer.disconnect();
                }
            });
        }, { threshold: 0.3 });
        observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, [trackSectionView]);
    const handleBlogClick = (post) => {
        if (typeof window === 'undefined')
            return;
        if (post.link) {
            trackExternalLink(post.link, post.title);
            window.open(post.link, '_blank', 'noopener,noreferrer');
        }
        else {
            trackClick(`blog_${post.id}`, 'link', { post_title: post.title });
            if (onBlogClick) {
                onBlogClick(post.id);
            }
        }
    };
    return (_jsx(SectionContainer, { id: "blog", ref: sectionRef, children: _jsxs(Container, { children: [_jsx(SectionHeader, { children: _jsx(SectionTitle, { children: "Latest from the Blog" }) }), _jsx(Grid, { children: _jsx(Content, { children: BLOG_POSTS.map((post) => (_jsxs(Card, { children: [_jsx(Tag, { children: post.category }), _jsx(CardTitle, { children: post.title }), _jsx(Excerpt, { children: post.excerpt }), _jsxs(BlogMeta, { children: [_jsxs("span", { children: [post.date, " \u2022 ", post.readTime] }), _jsx(BlogLink, { onClick: () => handleBlogClick(post), children: post.link ? 'View Publication' : 'Read article' })] })] }, post.id))) }) })] }) }));
};
export default Blog;
